module.exports = __webpack_public_path__ + "static/media/synth_08.8a6eeac6.mp3";